module.exports = __webpack_public_path__ + "static/media/75.7642f2fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/75.jpg
// module id = 633
// module chunks = 0